/** The session sequence the page or the Apple TV app last applied, for the TV diagnostics panel
 *  (Developer Tools on the phone). Read at render; nothing subscribes. */
export const diagState: { appliedSeq: number | null } = { appliedSeq: null };
